<template>
  <LoginComponent/>
</template>

<script>
  import LoginComponent from '../components/LoginComponent'

  export default {
    data() {
        return {
             mockAccount: {
                    username: "msoma",
                    password: "password"
                }
        }
    },
    components: {
      LoginComponent
    }
  }
</script>